import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

import { LoadingSpinner } from "../../../constants/const";
import { GetLanguageString } from "../../helper/Components";
import { ApiEducation } from "./ApiEducation";
import Draggable from "react-draggable";
import swal from "sweetalert";
import { GetSelectedLanguage } from "../../helper/Method";

const AddEducationType = ({ setEducationTypeAddModal }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [educationTypeValues, setEducationTypeValues] = useState({
    title: "",
    code: "",
  });
  const [errors, setErrors] = useState(educationTypeValues);
  const toggle = () => setEducationTypeAddModal(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const validate = () => {
    let temp = {};
    temp.title = educationTypeValues.title
      ? ""
      : t("settings_title_error_message");
    temp.code = educationTypeValues.code
      ? ""
      : t("settings_code_error_message");

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({
      ...errors,
      title: "",
      code: "",
    });
    setEducationTypeValues({
      ...educationTypeValues,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      setEducationTypeAddModal(false);
      ApiEducation()
        .addEducationType(educationTypeValues)
        .then((res) => {
          toggle();
          setLoading(false);
          swal({
            title: t("education_add_type_success"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "success",
            buttons: "OK",
          });
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          swal({
            title: "Error: " + err.response?.data || err,
            icon: "error",
            buttons: "OK",
          });
        });
    }
  };

  return (
    <div>
      <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
        <Modal isOpen={true} className="inmodal" autoFocus={false}>
          <ModalHeader className="modal-title" tag="h4">
            {<GetLanguageString props="education_add_type" />}
          </ModalHeader>
          {!loading ? (
            <Form onSubmit={handleSubmit}>
              <ModalBody>
              <FormGroup>
                  <Label>
                    {
                      <GetLanguageString props="settings_title" />
                    }
                  </Label>
                  <Input
                    autoFocus
                    type="text"
                    name="title"
                    className="no-drag"
                    value={educationTypeValues.title}
                    onChange={handleInputChange}
                    {...(errors.title && { invalid: true })}
                  />
                  {errors.title && (
                    <FormFeedback>
                      <h4>{errors.title}</h4>
                    </FormFeedback>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label>
                    {
                      <GetLanguageString props="settings_code" />
                    }
                  </Label>
                  <Input
                    type="text"
                    name="code"
                    className="no-drag"
                    value={educationTypeValues.code}
                    onChange={handleInputChange}
                    {...(errors.code && { invalid: true })}
                  />
                  {errors.code && (
                    <FormFeedback>
                      <h4>{errors.code}</h4>
                    </FormFeedback>
                  )}
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="white" onClick={toggle}>
                  {<GetLanguageString props="common_cancel" />}
                </Button>
                <Button color="primary" type="submit">
                  {<GetLanguageString props="common_save_changes" />}
                </Button>
              </ModalFooter>
            </Form>
          ) : (
            LoadingSpinner()
          )}
        </Modal>
      </Draggable>
    </div>
  );
};

export default AddEducationType;
